import './App.css';
import { useState, useEffect } from 'react';
import { Box, Button, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, Select, MenuItem, Card, CardContent, paperClasses, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Popover, Radio } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TablePagination from '@mui/material/TablePagination';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';

import Tree from 'react-d3-tree';

import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import './chatscopeOverride.css';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
  Button as ChatScopeButton,
} from "@chatscope/chat-ui-kit-react";

import { JsonTable, snakeToTitleCase } from './components/JsonTable';
import theme from './components/theme';
import { RecursiveJsonDisplay } from './components/RecursiveJson';
import { API_BASE_URL, OAuthButton } from './components/OAuth';

// make request of query to localhost:8000
function executeQuery(query, setData) {
  fetch(`${API_BASE_URL}/execute_query?query=${query}`, {
    method: 'GET',
    headers: {
      "ngrok-skip-browser-warning": "123"
    }
  })
    .then((res) => res.json())
    .then((data) => setData(data.data));
}

function formatDate(date) {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${hours}:${minutes}:${seconds} ${month}/${day}/${year}`;
}

function PopoverCustom({ PressMe, DisplayMe }) {

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <div onClick={handleClick}><PressMe /></div>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <DisplayMe />
      </Popover>
    </div>
  );
}


function RawDataStream({ setAgentActionsContent, setAgentContext }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [events, setEvents] = useState([]);
  const [pages, setPages] = useState(null);
  const handleChangePage = (
    event, newPage,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setAgentActionsContent(null);
    executeQuery("SELECT COUNT(*) FROM public.events", setPages);
  }, []);

  useEffect(() => {
    executeQuery(
      `SELECT 
            e.*,
            t.*,
            wi.name AS work_item_name
        FROM 
            public.events e
        LEFT JOIN 
            public.employee_event ee ON e.id = ee.event_id
        LEFT JOIN 
            public.employee_team et ON ee.employee_id = et.employee_id
        LEFT JOIN 
            public.teams t ON et.team_id = t.id
        LEFT JOIN 
            public.work_items wi ON e.work_item_id = wi.id
        ORDER BY 
            e.date ASC
        LIMIT 
            ${rowsPerPage}
        OFFSET 
            ${page * rowsPerPage};`,
      setEvents);
  }, [page, rowsPerPage, pages]);

  useEffect(() => {
    setAgentContext({
      page: "Events",
      description: "A bunch of events being displayed to the user in paginated form. This is the raw data stream portion of the demo.",
      page: page,
      rowsPerPage: rowsPerPage,
      totalPages: pages,
      data: events
    });
  }, [events]);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Events
        </Typography>
        <TablePagination
          component="div"
          count={pages && Array.isArray(pages) && pages.length > 0 && pages[0].count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Timeline>
          {
            events.map((event, index) => (
              <TimelineItem key={index}>
                <TimelineOppositeContent color="text.secondary">
                  {formatDate(new Date(event.date))}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  {(index < events.length - 1 || (pages && Array.isArray(pages) && pages.length > 0 && (page < pages[0].count - 1))) && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <PopoverCustom
                    PressMe={() => (
                      <div>
                        <strong>{event.data_source} </strong>
                        {
                          event.name ?
                            <>
                              mapped to
                              <strong> {event.name} </strong>
                            </> :
                            <>mapped to <strong>API and Developer Portal Team</strong></>
                        }
                        {
                          event.work_item_name ?
                            <>
                              <br />
                              <em>Project: {event.work_item_name} </em>
                            </> :
                            <>
                              <br />
                              <em>Project: Maintenance</em>
                            </>
                        }

                      </div>
                    )}
                    DisplayMe={() => (
                      <JsonTable jsonData={event.content} idx={event.id} />
                    )} />
                </TimelineContent>
              </TimelineItem>
            ))
          }
        </Timeline>
      </CardContent>
    </Card>
  )
};

function ProjectsSection({ projects, selectedProject, setSelectedProject, setAgentActionsContent, setAgentContext }) {

  const [date, setDate] = useState(dayjs('2025-01-01'));
  const [agentInfo, setAgentInfo] = useState(null);
  const [agentUpdates, setAgentUpdates] = useState(null);

  useEffect(() => {
    if (!selectedProject) return;
    const currentProject = projects.find((project) => project.key === selectedProject);
    const startDate = date.format('YYYY-MM-DD');
    const endDate = date.add(1, 'day').format('YYYY-MM-DD');
    executeQuery(`SELECT * FROM public.updates WHERE work_item_id = '${currentProject.id}' AND date >= '${startDate}' AND date < '${endDate}'`, setAgentInfo);
  }, [selectedProject, date]);

  useEffect(() => {
    if (agentInfo) {
      setAgentUpdates(JSON.parse(agentInfo[0].content));
      const currentProject = projects.find((project) => project.key === selectedProject);
      setAgentContext({
        page: "Projects",
        description: "A bunch of projects being displayed to the user. This is the projects portion of the demo.",
        selectedProject: selectedProject,
        selectedProjectData: currentProject,
        selectedDate: date,
        agentInfoDisplayed: agentUpdates,
        allProjects: projects
      });
    }
  }, [agentInfo]);

  if (!selectedProject && projects.length > 0) {
    setSelectedProject(projects[0].key);
    return null;
  } else if (!selectedProject) {
    return null;
  }

  const currentProject = projects.find((project) => project.key === selectedProject);

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Projects
        </Typography>
        <Select
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
        >
          {projects.map((project) => (
            <MenuItem key={project.key} value={project.key}>
              {project.key}
            </MenuItem>
          ))}
        </Select>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={date}
            onChange={(newValue) => setDate(newValue)}
          />
        </LocalizationProvider>
        {agentInfo && agentUpdates &&
          <RecursiveJsonDisplay data={agentUpdates} title={"Project Overview"} setAgentActionsContent={setAgentActionsContent} />
        }
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Project Details
            </Typography>
            <Typography variant="subtitle1">Name: {currentProject.name}</Typography>
            <Typography variant="subtitle1">Owner: {currentProject.employee_name} <em>{currentProject.employee_role}</em></Typography>
            <Typography variant="subtitle1">Parent OKR: {currentProject.parent_name} <em>{currentProject.parent_key}</em> (status: {currentProject.parent_status})</Typography>
            <Typography variant="subtitle2">Description: {currentProject.description}</Typography>
          </CardContent>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Progress To Date
            </Typography>
            <ul>
              {currentProject.progress_to_date.map((event, index) => (
                <li key={index}>{event}</li>
              ))}
            </ul>
          </CardContent>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Goals
            </Typography>
            <ul>
              {currentProject.goals_metrics.map((event, index) => (
                <li key={index}>{event}</li>
              ))}
            </ul>
            <hr />
            <Typography variant="p" gutterBottom><strong>{currentProject.goals_outcome}</strong> </Typography>
          </CardContent>
        </Card>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Timeline
            </Typography>
            {
              currentProject.timeline_expected.map((event, index) => (
                <Timeline key={index}>
                  <TimelineItem>
                    <TimelineOppositeContent color="text.secondary">
                      {event.split(': ')[0]}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot />
                      {index < currentProject.timeline_expected.length - 1 && <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent>
                      {event.split(': ')[1]}
                    </TimelineContent>
                  </TimelineItem>
                </Timeline>
              ))
            }
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
};

function TeamsSection({ teams, selectedTeam, setSelectedTeam, setAgentActionsContent, setAgentContext }) {

  const [employees, setEmployees] = useState([]);
  const [date, setDate] = useState(dayjs('2025-01-01'));
  const [agentInfo, setAgentInfo] = useState(null);
  const [agentUpdates, setAgentUpdates] = useState(null);
  const [currentTeam_, setCurrentTeam] = useState(null);

  useEffect(() => {
    const currentTeam = teams.find((team) => team.name === selectedTeam);
    if (!currentTeam) return;
    setCurrentTeam(currentTeam);
    const startDate = date.format('YYYY-MM-DD');
    const endDate = date.add(1, 'day').format('YYYY-MM-DD');
    executeQuery(`SELECT * FROM public.updates WHERE team_id = '${currentTeam.id}' AND date >= '${startDate}' AND date < '${endDate}'`, setAgentInfo);
  }, [selectedTeam, date]);

  useEffect(() => {
    if (agentInfo) {
      setAgentUpdates(JSON.parse(agentInfo[0].content));
      setAgentContext({
        page: "Teams",
        description: "A bunch of teams being displayed to the user. This is the teams portion of the demo.",
        selectedTeam: selectedTeam,
        selectedTeamData: currentTeam_,
        selectedTeamEmployees: employees,
        selectedDate: date,
        agentInfoDisplayed: agentInfo,
        agentUpdatesDisplayed: agentUpdates,
        allTeams: teams
      });
    }
  }, [agentInfo]);

  useEffect(() => {
    const currentTeam = teams.find((team) => team.name === selectedTeam);
    if (!currentTeam) return;
    executeQuery(`SELECT e.* FROM employees e JOIN employee_team et ON e.id = et.employee_id WHERE et.team_id = ${currentTeam.id}`, setEmployees);
  }, [selectedTeam]);

  if (!selectedTeam && teams.length > 0) {
    setSelectedTeam(teams[0].name);
    return null;
  } else if (!selectedTeam) {
    return null;
  }

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Teams
        </Typography>
        <Select
          value={selectedTeam}
          onChange={(e) => setSelectedTeam(e.target.value)}
        >
          {teams.map((team) => (
            <MenuItem key={team.name} value={team.name}>
              {team.name}
            </MenuItem>
          ))}
        </Select>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={date}
            onChange={(newValue) => setDate(newValue)}
          />
        </LocalizationProvider>
        <br />
        {
          currentTeam_ && <Typography variant="h6" sx={{ margin: "10px" }} gutterBottom>Team Lead: {currentTeam_.leader_name} <em>{currentTeam_.leader_role}</em></Typography>
        }

        {agentInfo && agentUpdates &&
          <RecursiveJsonDisplay data={agentUpdates} title={"Team Overview"} setAgentActionsContent={setAgentActionsContent} />
        }
        <Box mt={2}>
          <TableContainer>
            <Table sx={{ maxWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Role</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {employees.map((employee, index) => (
                  <TableRow key={index}>
                    <TableCell>{employee.name}</TableCell>
                    <TableCell>{employee.role}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

function GoalSection({ okrs, okrslevels, setAgentActionsContent, setAgentContext }) {

  const [selectedValue, setSelectedValue] = useState(0);
  const [treeData, setTreeData] = useState(null);

  useEffect(() => {
    const treeData_ = buildTreeData().map(transformToTreeNode)
    setTreeData(treeData_);
    setAgentActionsContent(null);
    setAgentContext({
      page: "Goals",
      description: "A bunch of goals in the form of parent to child OKRs and child projects are being displayed to the user. This is the goals portion of the demo.",
      selectedValue: selectedValue,
      selectedBranchOfTree: treeData_[selectedValue],
      entireTree: treeData_,
      allGoals: okrs,
      allGoalsLevels: okrslevels
    });
  }, [selectedValue]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  if (!okrs || !okrs.length || !okrslevels.length) {
    return null;
  }

  function buildTreeData() {
    // Create a lookup table for each item by ID
    const lookup = {};
    okrs.forEach(item => {
      item.children = []; // prepare for child nodes
      lookup[item.id] = item;
    });

    // Build the tree structure based on relationships
    okrslevels.forEach(link => {
      const parent = lookup[link.parent_id];
      const child = lookup[link.child_id];
      if (parent && child) {
        parent.children.push(child);
      }
    });

    // Find the root nodes (types OBJECTIVE) and return them
    return okrs.filter(item => item.type === 'OBJECTIVE');
  }

  function transformToTreeNode(node) {
    return {
      key: node.key,
      name: node.name,
      status: node.status,
      employee_name: node.employee_name,
      employee_role: node.employee_role,
      children: node.children.map(transformToTreeNode),
    };
  }

  const renderCustomNode = ({ nodeDatum }) => (
    <g>
      <foreignObject x="-80" y="-70" width="160" height="140">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{ textAlign: "center", fontSize: "14px", fontWeight: "bold" }}>
          {nodeDatum.key}
        </div>
        <div xmlns="http://www.w3.org/1999/xhtml" style={{ textAlign: "center", fontSize: "10px", wordWrap: "break-word" }}>
          {nodeDatum.name}
        </div>
        <div xmlns="http://www.w3.org/1999/xhtml" style={{ textAlign: "center", fontSize: "8px", wordWrap: "break-word" }}>
          {nodeDatum.employee_name}
          <em xmlns="http://www.w3.org/1999/xhtml" style={{ marginLeft: "2px" }} >
            {nodeDatum.employee_role}
          </em>
        </div>
        <div xmlns="http://www.w3.org/1999/xhtml" style={{ textAlign: "center", fontSize: "8px" }}>
          {nodeDatum.status}
        </div>
      </foreignObject>
    </g>
  );

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Goals
        </Typography>
        <div>
          {
            treeData && treeData.map((_, index) => (
              <Radio
                checked={selectedValue == index}
                onChange={handleChange}
                value={index}
                name="radio-buttons"
              />
            ))
          }
        </div>
        <Box width="100%" height={"100vh"}>
          {
            treeData && selectedValue >= 0 && selectedValue < treeData.length && <Tree data={treeData[selectedValue]} orientation="horizontal"
              renderCustomNodeElement={renderCustomNode}
              translate={{ x: 100, y: 300 }} pathClassFunc={() => 'white-stroke'} />
          }

        </Box>
      </CardContent>
    </Card>
  );
};

function UpdateSection({ leaders, selectedLeader, setSelectedLeader, setAgentActionsContent, setAgentContext }) {

  const [date, setDate] = useState(dayjs('2025-01-01'));
  const [agentInfo, setAgentInfo] = useState(null);
  const [agentUpdates, setAgentUpdates] = useState(null);
  const [currentLeader, setCurrentLeader] = useState(null);

  useEffect(() => {
    const currentTeam = leaders.find((team) => team.employee_name === selectedLeader);
    setCurrentLeader(currentTeam);
    if (!currentTeam) return;
    const startDate = date.format('YYYY-MM-DD');
    const endDate = date.add(1, 'day').format('YYYY-MM-DD');
    executeQuery(`SELECT * FROM public.updates WHERE team_id = '${currentTeam.id}' AND date >= '${startDate}' AND date < '${endDate}'`, setAgentInfo);
  }, [selectedLeader, date]);

  useEffect(() => {
    if (agentInfo) {
      setAgentUpdates(JSON.parse(agentInfo[0].content));
      setAgentContext({
        page: "Updates",
        description: "A bunch of updates being displayed to the user. This is the updates portion of the demo.",
        selectedLeader: selectedLeader,
        selectedLeaderData: currentLeader,
        selectedDate: date,
        agentInfoDisplayed: agentInfo,
        agentUpdatesDisplayed: agentUpdates,
        allLeaders: leaders
      });
    }
  }, [agentInfo]);

  if (!selectedLeader && leaders.length > 0) {
    setSelectedLeader(leaders[0].employee_name);
    return null;
  } else if (!selectedLeader) {
    return null;
  }

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Your Update
        </Typography>
        <Select
          value={selectedLeader}
          onChange={(e) => setSelectedLeader(e.target.value)}
        >
          {
            leaders.map((leader, index) => (
              <MenuItem key={leader.employee_name} value={leader.employee_name}>
                {leader.employee_name}
              </MenuItem>
            ))
          }
        </Select>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={date}
            onChange={(newValue) => setDate(newValue)}
          />
        </LocalizationProvider>
        {agentInfo && agentUpdates &&
          <RecursiveJsonDisplay data={agentUpdates} title={`Team Update ${currentLeader ? "for " + currentLeader.name : ""}`} setAgentActionsContent={setAgentActionsContent} />
        }

      </CardContent>
    </Card>
  );
};

function OAuthSection() {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company');
  return (
    <Card variant="outlined">
      <CardContent>

        <Typography variant="h6" gutterBottom>
          <img src="/braid-logo.svg" alt="Braid" style={{ display: "inline" }} /> Integrations
        </Typography>
        <br />
        <Typography variant="subtitle1" gutterBottom>Welcome {company ? snakeToTitleCase(company) : "to Braid"}! To get started, please connect your accounts below.</Typography>
        <Box sx={{ display: 'flex' }}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Jira/Confluence</Typography>
              <OAuthButton company={company} type="jira" />
            </CardContent>
          </Card>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Github</Typography>
              <OAuthButton company={company} type="github" rawTokenSubmit/>
            </CardContent>
          </Card>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Slack</Typography>
              <OAuthButton company={company} type="slack" />
            </CardContent>
          </Card>
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h6" gutterBottom>Google Drive</Typography>
              <OAuthButton company={company} type="google_drive" />
            </CardContent>
          </Card>
        </Box>
      </CardContent>
    </Card>
  );
}

function ChatBot({ agentContext, agentActionsContent }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [iter, setIter] = useState(0);

  function sendMessage(content) {
    const messages_ = [...messages, { content, self: true }]
    setMessages(messages_);
    setLoading(true);
    const iter_ = iter;
    fetch(`${API_BASE_URL}/chatbot`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "ngrok-skip-browser-warning": "123"
      },
      body: JSON.stringify({ message: content, history: messages_.slice(-20), context: agentContext, content: agentActionsContent })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (iter_ == iter) {
          setMessages([...messages_, { content: data.response, self: false }]);
          setLoading(false);
        }
      }).catch((error) => {
        console.error(error);
        if (iter_ == iter) {
          setMessages([...messages_, { content: "Sorry, I'm having trouble connecting to the server. Please try again.", self: false }]);
          setLoading(false);
        }
      });
  }

  function resetChat() {
    setIter(iter + 1);
    setMessages([]);
    setLoading(false);
  }

  return (
    <Box style={{ position: "relative", height: "100%" }}>
      <MainContainer>
        <ChatContainer>
          <MessageList
            typingIndicator={loading && <TypingIndicator content="Braidy is thinking" />}>
            <Message model={{ message: "Ask Anything", direction: "incoming", position: "single" }} />
            {messages.map((m, i) => <Message key={i} model={{ message: m.content, direction: m.self ? "outgoing" : "incoming", position: "single" }} />)}
          </MessageList>
          <div as="MessageInput" style={{ display: "flex", flexDirection: "row" }}>
            <MessageInput
              placeholder="Ask Braidy here"
              attachButton={false}
              onSend={sendMessage}
              sendDisabled={loading}
              sendOnReturnDisabled={loading}
              style={{ flexGrow: 1, borderTop: 0, flexShrink: "initial", }} />
            <ChatScopeButton icon={<DeleteIcon />} onClick={resetChat} style={{ fontSize: "1.2em", paddingLeft: "0.2em", paddingRight: "0.2em" }} />
          </div>
        </ChatContainer>
      </MainContainer>

    </Box>
  );
}

function Demo() {
  const [selectedPage, setSelectedPage] = useState('Events');
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedLeader, setSelectedLeader] = useState(null);
  const [projects, setProjects] = useState([]);
  const [okrs, setOKRs] = useState([]);
  const [okrslevels, setOKRsLevels] = useState([]);
  const [teams, setTeams] = useState([]);
  const [leaders, setLeaders] = useState([]);
  const [agentActionsContent, setAgentActionsContent] = useState(null);
  const [agentContext, setAgentContext] = useState(null);

  useEffect(() => {
    executeQuery(`SELECT wih.*, e.name AS employee_name, e.role AS employee_role, parent.name AS parent_name, parent.status AS parent_status, parent.key AS parent_key 
      FROM public.work_items wih
      JOIN public.employees e
      ON wih.owner_id = e.id
      LEFT JOIN public.work_item_hierarchy wih_parent
      ON wih.id = wih_parent.child_id
      LEFT JOIN public.work_items parent
      ON wih_parent.parent_id = parent.id
      WHERE wih.type = 'PROJECT'
      ORDER BY wih.id ASC;`, setProjects);
    executeQuery(`SELECT t.*, e.name AS leader_name, e.role AS leader_role 
      FROM public.teams t 
      JOIN public.employees e 
      ON t.team_lead_id = e.id 
      ORDER BY t.id ASC;`, setTeams);
    executeQuery(`SELECT wih.*, e.name AS employee_name, e.role AS employee_role
      FROM public.work_items wih
      JOIN public.employees e
      ON wih.owner_id = e.id;`, setOKRs);
    executeQuery("SELECT * FROM public.work_item_hierarchy ORDER BY child_id ASC, parent_id ASC", setOKRsLevels);
    executeQuery("SELECT t.*, e.name AS employee_name, e.role AS employee_role FROM teams t JOIN employees e ON t.team_lead_id = e.id;", setLeaders);
  }, []);

  const pages = {
    'Events': <RawDataStream setAgentActionsContent={setAgentActionsContent} setAgentContext={setAgentContext} />,
    Projects: (
      <ProjectsSection
        projects={projects}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        setAgentActionsContent={setAgentActionsContent}
        setAgentContext={setAgentContext}
      />
    ),
    Teams: (
      <TeamsSection
        teams={teams}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        setAgentActionsContent={setAgentActionsContent}
        setAgentContext={setAgentContext}
      />
    ),
    Goals: <GoalSection okrs={okrs} okrslevels={okrslevels} setAgentActionsContent={setAgentActionsContent} setAgentContext={setAgentContext} />,
    Updates: <UpdateSection leaders={leaders} selectedLeader={selectedLeader} setSelectedLeader={setSelectedLeader} setAgentActionsContent={setAgentActionsContent} setAgentContext={setAgentContext} />,
  };

  return (

    <Box display="flex" height="calc(100vh - 48px)">

      {/* Sidebar */}
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{ width: 240, flexShrink: 0, '& .MuiDrawer-paper': { width: 240 } }}
      >
        <List>
          <ListItem>
            <ListItemIcon>
              <img src="/braid-logo.svg" alt="Braid" />
            </ListItemIcon>
          </ListItem>
          {Object.keys(pages).map((page) => (
            <ListItem key={page} disablePadding>
              <ListItemButton onClick={() => setSelectedPage(page)}>
                <ListItemText primary={page} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box component="main" flexGrow={1} p={3}>
        {pages[selectedPage]}
      </Box>

      {/* Chatbot Sidebar */}
      <Drawer
        variant="permanent"
        anchor="right"
        sx={{ width: 400, flexShrink: 0, '& .MuiDrawer-paper': { width: 400, display: 'flex', flexDirection: 'column' } }} // Adjust width as needed
      >
        <Box p={2}>
          {
            agentActionsContent &&
            <Card variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Agent Actions
                </Typography>
                {
                  agentActionsContent.map((action, index) => (
                    <Typography key={index} variant="paragraph" gutterBottom>
                      • {action}<br />
                    </Typography>
                  ))
                }
              </CardContent>
            </Card>
          }
        </Box>
        <Box p={2} sx={{ flexGrow: 1, overflow: 'auto' }}>

          <ChatBot agentContext={agentContext} agentActionsContent={agentActionsContent} />
        </Box>
      </Drawer>
    </Box>
  );
};

function OAuth() {
  return (
    <Box style={{ minHeight: "80vh", height: "fit-content" }}>
      <OAuthSection />
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/oauth" element={<OAuth />} />
          <Route path="/demo" element={<Demo />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
